import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { startHydration } from './utils/hydration';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Прод-збірка проходить пререндер (scripts/prerender.js), тому в #root уже є
// розмітка — гідруємо її замість того, щоб стирати клієнтським рендером.
// Прапорець гідрації каже першому екрану не програвати анімацію появи
// поверх уже намальованого (src/utils/hydration.js).
if (container.hasChildNodes()) {
  startHydration();
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
